



















import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BoxDiagramButton extends Vue { 
	@Prop() public text!: string
	@Prop() public totalUnit!: number
	@Prop({ default: 210 }) public width!: string
	@Prop(Function) public clickEvent!: any

    onClick () {
		this.clickEvent()
    }

}
